// src/components/VarnishContext.tsx
import React from "react";
import { jsx } from "react/jsx-runtime";
var defaultHeaderHeight = 113;
var VarnishContext = React.createContext({
  layout: "center-aligned",
  currentHeaderHeight: defaultHeaderHeight,
  setHeaderHeight() {
  }
});
function DefaultAppLayoutProvider({ layout, children }) {
  const [currentHeaderHeight, setHeaderHeight] = React.useState(defaultHeaderHeight);
  return React.useMemo(() => {
    return /* @__PURE__ */ jsx(
      VarnishContext.Provider,
      {
        value: {
          layout,
          currentHeaderHeight,
          setHeaderHeight
        },
        children
      }
    );
  }, [layout, children, currentHeaderHeight]);
}
var VarnishContext_default = DefaultAppLayoutProvider;

export {
  defaultHeaderHeight,
  VarnishContext,
  DefaultAppLayoutProvider,
  VarnishContext_default
};
//# sourceMappingURL=chunk-BDRB3LP3.js.map